export default __webpack_public_path__ + "static/media/answerl.c5870909.mp3";